// combo-swap: reads combo_promo_rule metaobjects rendered by the
// combo-promo-rules snippet and applies them to the AJAX cart.
//
// SWAP rule  : if trigger variant is in cart, replace with replacement variant (same quantity).
// COMBO rule : if both trigger variants are in cart, replace min(qA, qB) pairs with replacement.
//
// Rules are filtered by `enabled` and date range (`startsAt`, `endsAt` inclusive, store UTC).

(function () {
  const rulesNode = document.getElementById('combo-promo-rules');
  if (!rulesNode) return;

  let rules;
  try {
    rules = JSON.parse(rulesNode.textContent);
  } catch (err) {
    console.error('combo-swap: failed to parse rules JSON', err);
    return;
  }
  if (!Array.isArray(rules) || rules.length === 0) return;

  function isActive(rule) {
    if (!rule.enabled) return false;
    const today = new Date().toISOString().slice(0, 10);
    if (rule.startsAt && today < rule.startsAt) return false;
    if (rule.endsAt && today > rule.endsAt) return false;
    return true;
  }

  function findItem(cart, variantId) {
    if (!variantId) return null;
    return cart.items.find(item => item.variant_id === variantId) || null;
  }

  const KNOWN_CART_SECTIONS = [
    'cart-drawer',
    'cart-icon-bubble',
    'cart-live-region-text',
    'main-cart-items',
    'main-cart-footer',
    'header',
  ];

  function cartSectionIds() {
    const ids = new Set(KNOWN_CART_SECTIONS);
    document.querySelectorAll('[id^="shopify-section-"]').forEach(el => {
      const id = el.id.replace('shopify-section-', '');
      if (/cart|header/i.test(id)) ids.add(id);
    });
    return Array.from(ids);
  }

  function applySections(sections) {
    if (!sections || Object.keys(sections).length === 0) return false;
    let applied = false;
    for (const [id, html] of Object.entries(sections)) {
      const target = document.getElementById(`shopify-section-${id}`);
      if (target && html) {
        target.outerHTML = html;
        applied = true;
      }
    }
    return applied;
  }

  let running = false;
  let scheduled = false;

  async function applyRules() {
    if (running) return;
    running = true;
    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      const updates = {};
      const additions = [];

      for (const rule of rules) {
        if (!isActive(rule)) continue;

        function buildAddition(quantity) {
          const item = { id: rule.replacementVariantId, quantity };
          if (rule.customerMessage) {
            item.properties = { Promo: rule.customerMessage };
          }
          return item;
        }

        if (rule.type === 'SWAP') {
          const trigger = findItem(cart, rule.triggerVariantId);
          if (!trigger) continue;
          if (trigger.variant_id === rule.replacementVariantId) continue;
          updates[trigger.key] = 0;
          additions.push(buildAddition(trigger.quantity));
        } else if (rule.type === 'COMBO') {
          const a = findItem(cart, rule.triggerVariantId);
          const b = findItem(cart, rule.secondTriggerVariantId);
          if (!a || !b) continue;
          const pairs = Math.min(a.quantity, b.quantity);
          if (pairs <= 0) continue;
          updates[a.key] = a.quantity - pairs;
          updates[b.key] = b.quantity - pairs;
          additions.push(buildAddition(pairs));
        }
      }

      const hasUpdates = Object.keys(updates).length > 0;
      if (!hasUpdates && additions.length === 0) return;

      const sections = cartSectionIds();
      let lastResponse = null;

      if (hasUpdates) {
        lastResponse = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates, sections }),
        }).then(r => r.json());
      }

      if (additions.length > 0) {
        lastResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: additions, sections }),
        }).then(r => r.json());
      }

      applySections(lastResponse && lastResponse.sections);
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } catch (err) {
      console.error('combo-swap: rule application failed', err);
    } finally {
      running = false;
    }
  }

  function scheduleApply() {
    if (running || scheduled) return;
    scheduled = true;
    queueMicrotask(() => {
      scheduled = false;
      applyRules();
    });
  }

  function isCartMutation(resource) {
    const url =
      typeof resource === 'string' ? resource :
      resource instanceof URL ? resource.href :
      resource && resource.url ? resource.url : '';
    return url.includes('/cart/add') || url.includes('/cart/update') || url.includes('/cart/change');
  }

  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const [resource] = args;
    const response = await originalFetch.apply(this, args);
    if (!running && isCartMutation(resource)) {
      scheduleApply();
    }
    return response;
  };

  document.addEventListener('DOMContentLoaded', () => {
    const path = window.location.pathname;
    if (path.includes('/cart') || path.includes('/checkout')) {
      applyRules();
    }
  });
})();
